// Localização: frontend/src/components/Financeiro/FormSubcategoria.jsx

import React, { useState, useEffect } from 'react';
import PrimaryButton from '../Common/PrimaryButton';

const FormSubcategoria = ({ initialData, categorias = [], onSubmit, onClose, isEditing }) => {
    const [formData, setFormData] = useState({
        categoria_id: '',
        nome: '',
        descricao: '',
        ativo: true,
        ...initialData
    });
    const [error, setError] = useState(null);

    // Filtrar categorias ativas
    const categoriasAtivas = categorias.filter(cat => cat.ativo !== false);

    useEffect(() => {
        // Se estiver editando e não tiver categoria_id, tentar pegar da categoria relacionada
        if (isEditing && initialData) {
            if (!formData.categoria_id) {
                const categoriaId = initialData.categoria?.id || initialData.categoria_id;
                if (categoriaId) {
                    setFormData(prev => ({
                        ...prev,
                        categoria_id: categoriaId
                    }));
                }
            }
        }
    }, [initialData, isEditing, formData.categoria_id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);

        // Validações
        if (!formData.categoria_id || !formData.nome) {
            setError('Categoria e nome são obrigatórios.');
            return;
        }

        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                    {error}
                </div>
            )}

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Categoria <span className="text-red-500">*</span>
                </label>
                <select
                    name="categoria_id"
                    value={formData.categoria_id}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                    required
                >
                    <option value="">Selecione uma categoria</option>
                    {categoriasAtivas.map(categoria => (
                        <option key={categoria.id} value={categoria.id}>
                            {categoria.nome} ({categoria.tipo})
                        </option>
                    ))}
                </select>
                {categoriasAtivas.length === 0 && (
                    <p className="mt-1 text-xs text-red-500">
                        Nenhuma categoria ativa disponível. Crie uma categoria primeiro.
                    </p>
                )}
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nome da Subcategoria <span className="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                    required
                    placeholder="Ex: Consulta Médica"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Descrição
                </label>
                <textarea
                    name="descricao"
                    value={formData.descricao || ''}
                    onChange={handleChange}
                    rows="3"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                    placeholder="Descrição da subcategoria..."
                />
            </div>

            {isEditing && (
                <div className="flex items-center">
                    <input
                        type="checkbox"
                        name="ativo"
                        checked={formData.ativo}
                        onChange={handleChange}
                        className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded"
                    />
                    <label className="ml-2 block text-sm text-gray-700">
                        Subcategoria ativa
                    </label>
                </div>
            )}

            <div className="flex justify-end space-x-2 mt-6 pt-4 border-t border-gray-200">
                <PrimaryButton
                    type="button"
                    onClick={onClose}
                    className="bg-gray-500 hover:bg-gray-700"
                >
                    Cancelar
                </PrimaryButton>
                <PrimaryButton type="submit">
                    {isEditing ? 'Salvar Alterações' : 'Cadastrar'}
                </PrimaryButton>
            </div>
        </form>
    );
};

export default FormSubcategoria;

